(() => {
  "use strict";

  const CONTAINER_SELECTOR = ".shopify_subscriptions_app_container";
  const SECTION_SELECTOR = ".shopify_subscriptions_app_block";

  let refreshFrame = null;

  function createElement(tag, className = "", text = "") {
    const element = document.createElement(tag);

    if (className) {
      element.className = className;
    }

    if (text) {
      element.textContent = text;
    }

    return element;
  }

  function getGroups(section) {
    const oneTimeInput = section.querySelector(
      'input[data-radio-type="one_time_purchase"]'
    );

    const subscriptionInput = section.querySelector(
      'input[data-radio-type="selling_plan_group"]'
    );

    return {
      oneTimeInput,
      subscriptionInput,
      oneTimeGroup:
        oneTimeInput?.closest(".subscription_group") || null,
      subscriptionGroup:
        subscriptionInput?.closest(".subscription_group") || null,
    };
  }

  function getSelectData(section) {
    const select = section.querySelector(".group_dropdown");

    if (!select || !select.options.length) {
      return null;
    }

    const selectedOption =
      select.options[select.selectedIndex] || select.options[0];

    const { oneTimeInput, subscriptionInput } = getGroups(section);

    return {
      select,
      selectedOption,

      selectedText:
        selectedOption?.textContent?.trim() || "",

      originalPrice:
        oneTimeInput?.dataset.variantCompareAtPrice ||
        subscriptionInput?.dataset.variantCompareAtPrice ||
        selectedOption?.dataset.variantCompareAtPrice ||
        "",

      oneTimePrice:
        oneTimeInput?.dataset.variantPrice || "",

      subscriptionPrice:
        selectedOption?.dataset.variantPrice ||
        subscriptionInput?.dataset.variantPrice ||
        "",
    };
  }

  function extractDiscount(text = "") {
    const match = text.match(/(\d+(?:[.,]\d+)?)\s*%/);

    return match ? `${match[1]}%` : "";
  }

  function splitOptionText(text = "") {
    const trimmedText = text
      .replace(/[✓✔︎✔️]/g, "")
      .trim();
    const match = trimmedText.match(
      /^(.*?)(?:[\s,–—-]+)?(\d+(?:[.,]\d+)?\s*%\s*off)\s*$/i
    );

    if (!match) {
      return {
        label: trimmedText,
        discount: "",
      };
    }

    return {
      label: match[1].trim(),
      discount: match[2].trim(),
    };
  }

  function renderFrequencyText(target, text = "") {
    const optionText = splitOptionText(text);

    target.textContent = "";
    target.appendChild(
      createElement(
        "span",
        "lamel-frequency__option-text",
        optionText.label
      )
    );

    if (optionText.discount) {
      target.appendChild(
        createElement(
          "span",
          "lamel-frequency__option-discount",
          optionText.discount
        )
      );
    }
  }

  function renderSelectedFrequency(target, text = "") {
    const optionText = splitOptionText(text);
    const selectedText = target.querySelector(
      ".lamel-frequency__selected"
    );
    const selectedDiscount = target.querySelector(
      ".lamel-frequency__selected-actions .lamel-frequency__option-discount"
    );

    if (selectedText) {
      selectedText.textContent = optionText.label;
    }

    if (selectedDiscount) {
      selectedDiscount.textContent = optionText.discount;
      selectedDiscount.hidden = !optionText.discount;
    }
  }

  function removeCurrencyCode(value = "") {
    return String(value)
      .trim()
      .replace(/\s+[A-Z]{3}$/i, "")
      .trim();
  }

  function parseMoney(value = "") {
    const normalized = String(value)
      .replace(/\s/g, "")
      .replace(",", ".")
      .replace(/[^\d.-]/g, "");

    const number = Number.parseFloat(normalized);

    return Number.isFinite(number) ? number : null;
  }

  function getMoneyPrefix(value = "") {
    const cleanedValue = removeCurrencyCode(value);
    const match = cleanedValue.match(/^[^\d-]+/);

    return match ? match[0].trim() : "";
  }

  function formatSaving(originalPrice, activePrice) {
    const originalValue = parseMoney(originalPrice);
    const activeValue = parseMoney(activePrice);

    if (
      originalValue === null ||
      activeValue === null ||
      originalValue <= activeValue
    ) {
      return "";
    }

    const prefix =
      getMoneyPrefix(originalPrice) ||
      getMoneyPrefix(activePrice) ||
      "$";

    return `${prefix}${(originalValue - activeValue).toFixed(2)}`;
  }

  function createPrice(comparePrice, mainPrice, showCompare) {
    const wrapper = createElement(
      "div",
      "lamel-subscription-price"
    );

    const cleanComparePrice = removeCurrencyCode(comparePrice);
    const cleanMainPrice = removeCurrencyCode(mainPrice);

    if (
      showCompare &&
      cleanComparePrice &&
      cleanMainPrice &&
      cleanComparePrice !== cleanMainPrice
    ) {
      wrapper.appendChild(
        createElement(
          "span",
          "lamel-subscription-price__compare",
          cleanComparePrice
        )
      );
    }

    wrapper.appendChild(
      createElement(
        "span",
        "lamel-subscription-price__main",
        cleanMainPrice
      )
    );

    return wrapper;
  }

  function setRadio(input) {
    if (!input || input.disabled || input.checked) {
      return;
    }

    input.click();
  }

  function addHeading(section) {
    const planCard = section.querySelector(".plan_card");

    if (!planCard) {
      return;
    }

    let heading = planCard.querySelector(
      ".lamel-subscriptions-heading"
    );

    if (!heading) {
      heading = createElement(
        "div",
        "lamel-subscriptions-heading"
      );

      heading.appendChild(
        createElement(
          "h3",
          "lamel-subscriptions-heading__title",
          "Choose Plan"
        )
      );

      heading.appendChild(
        createElement(
          "div",
          "lamel-subscriptions-heading__saving"
        )
      );

      planCard.prepend(heading);
    }

    const title = heading.querySelector(
      ".lamel-subscriptions-heading__title"
    );

    if (title) {
      title.textContent = "Choose Plan";
    }
  }

  function renameLabels(section) {
    const {
      oneTimeGroup,
      subscriptionGroup,
    } = getGroups(section);

    const oneTimeLabel = oneTimeGroup?.querySelector(
      ".group_list_item span"
    );

    const subscriptionLabel = subscriptionGroup?.querySelector(
      ".group_name"
    );

    if (oneTimeLabel) {
      oneTimeLabel.textContent = "One-time purchase";
    }

    if (subscriptionLabel) {
      subscriptionLabel.textContent = "Subscribe & save";
    }
  }

  function buildAccordion(section) {
    const planCard = section.querySelector(".plan_card");
    const data = getSelectData(section);

    if (
      !planCard ||
      !data ||
      planCard.querySelector(".lamel-frequency")
    ) {
      return;
    }

    const accordion = createElement("div", "lamel-frequency");

    const trigger = createElement(
      "button",
      "lamel-frequency__button"
    );

    trigger.type = "button";
    trigger.setAttribute("aria-expanded", "false");

    const labelWrapper = createElement(
      "span",
      "lamel-frequency__button-label"
    );

    labelWrapper.appendChild(
      createElement(
        "span",
        "lamel-frequency__eyebrow",
        "Delivery frequency"
      )
    );

    const selectedLabel = createElement(
      "span",
      "lamel-frequency__selected"
    );

    labelWrapper.appendChild(selectedLabel);

    trigger.appendChild(labelWrapper);

    const selectedActions = createElement(
      "span",
      "lamel-frequency__selected-actions"
    );

    selectedActions.appendChild(
      createElement(
        "span",
        "lamel-frequency__option-discount"
      )
    );

    selectedActions.appendChild(
      createElement("span", "lamel-frequency__icon")
    );

    trigger.appendChild(selectedActions);
    renderSelectedFrequency(trigger, data.selectedText);

    const panel = createElement(
      "div",
      "lamel-frequency__panel"
    );

    const panelInner = createElement(
      "div",
      "lamel-frequency__panel-inner"
    );

    const optionsWrapper = createElement(
      "div",
      "lamel-frequency__options"
    );

    Array.from(data.select.options).forEach((option) => {
      const button = createElement(
        "button",
        "lamel-frequency__option"
      );

      button.type = "button";
      button.dataset.value = option.value;
      button.setAttribute("role", "option");

      const optionLabel = createElement(
        "span",
        "lamel-frequency__option-label"
      );

      renderFrequencyText(optionLabel, option.textContent);
      button.appendChild(optionLabel);

      optionsWrapper.appendChild(button);
    });

    panelInner.appendChild(optionsWrapper);
    panel.appendChild(panelInner);

    accordion.appendChild(trigger);
    accordion.appendChild(panel);

    planCard.prepend(accordion);
  }

  function addBenefits(section) {
    const planCard = section.querySelector(".plan_card");

    if (
      !planCard ||
      planCard.querySelector(".lamel-subscription-benefits")
    ) {
      return;
    }

    const benefits = createElement(
      "div",
      "lamel-subscription-benefits"
    );

    [
      "Save on every delivery",
      "Never run out of your favorites",
      "Skip or cancel anytime",
      "Automatic recurring delivery",
    ].forEach((text) => {
      const item = createElement(
        "p",
        "lamel-subscription-benefit"
      );

      item.appendChild(
        createElement(
          "span",
          "lamel-subscription-benefit__icon",
          "✓"
        )
      );

      item.appendChild(document.createTextNode(text));
      benefits.appendChild(item);
    });

    planCard.appendChild(benefits);
  }

  function updatePrices(section) {
    const data = getSelectData(section);

    if (!data) {
      return;
    }

    const {
      oneTimeGroup,
      subscriptionGroup,
    } = getGroups(section);

    const subscriptionWrapper =
      subscriptionGroup?.querySelector(
        ".title_and_price_wrapper"
      );

    const oneTimeWrapper =
      oneTimeGroup?.querySelector(
        ".title_and_price_wrapper"
      );

    subscriptionGroup
      ?.querySelector(".lamel-subscription-price")
      ?.remove();

    oneTimeGroup
      ?.querySelector(".lamel-subscription-price")
      ?.remove();

    if (subscriptionWrapper) {
      subscriptionWrapper.appendChild(
        createPrice(
          data.oneTimePrice,
          data.subscriptionPrice,
          true
        )
      );
    }

    if (oneTimeWrapper) {
      oneTimeWrapper.appendChild(
        createPrice(
          "",
          data.oneTimePrice,
          false
        )
      );
    }
  }

  function updateHeadingSaving(section) {
    const data = getSelectData(section);

    if (!data) {
      return;
    }

    const {
      oneTimeInput,
      subscriptionInput,
    } = getGroups(section);

    const savingElement = section.querySelector(
      ".lamel-subscriptions-heading__saving"
    );

    if (!savingElement) {
      return;
    }

    let activePrice = data.oneTimePrice;

    if (subscriptionInput?.checked) {
      activePrice = data.subscriptionPrice;
    } else if (oneTimeInput?.checked) {
      activePrice = data.oneTimePrice;
    }

    const saving = formatSaving(
      data.originalPrice,
      activePrice
    );

    savingElement.textContent = saving
      ? `You save ${saving}`
      : "";

    savingElement.hidden = !saving;
  }

  function updateBadge(section) {
    const data = getSelectData(section);
    const { subscriptionGroup } = getGroups(section);

    if (!data || !subscriptionGroup) {
      return;
    }

    let badge = subscriptionGroup.querySelector(
      ".lamel-subscription-save-badge"
    );

    if (!badge) {
      badge = createElement(
        "div",
        "lamel-subscription-save-badge"
      );

      subscriptionGroup.appendChild(badge);
    }

    const discount = extractDiscount(data.selectedText);

    badge.textContent = discount
      ? `SAVE ${discount} ON EVERY DELIVERY`
      : "SUBSCRIBE & SAVE";
  }

  function updateAccordion(section) {
    const data = getSelectData(section);
    const accordion = section.querySelector(".lamel-frequency");

    if (!data || !accordion) {
      return;
    }

    const selectedText = accordion.querySelector(
      ".lamel-frequency__button"
    );

    if (selectedText) {
      renderSelectedFrequency(selectedText, data.selectedText);
    }

    accordion
      .querySelectorAll(".lamel-frequency__option")
      .forEach((button) => {
        const selected =
          button.dataset.value === data.select.value;

        button.classList.toggle("is-selected", selected);

        button.setAttribute(
          "aria-selected",
          selected ? "true" : "false"
        );
      });
  }

  function updateActiveState(section) {
    const {
      oneTimeInput,
      subscriptionInput,
      oneTimeGroup,
      subscriptionGroup,
    } = getGroups(section);

    oneTimeGroup?.classList.toggle(
      "is-active",
      Boolean(oneTimeInput?.checked)
    );

    subscriptionGroup?.classList.toggle(
      "is-active",
      Boolean(subscriptionInput?.checked)
    );
  }

  function syncSection(section) {
    updatePrices(section);
    updateHeadingSaving(section);
    updateBadge(section);
    updateAccordion(section);
    updateActiveState(section);
  }

  function initializeSection(section) {
    if (!section) {
      return;
    }

    if (section.dataset.lamelInitialized !== "true") {
      addHeading(section);
      renameLabels(section);
      buildAccordion(section);
      addBenefits(section);

      section.dataset.lamelInitialized = "true";
    }

    syncSection(section);
  }

  function initializeAll() {
    document
      .querySelectorAll(CONTAINER_SELECTOR)
      .forEach((container) => {
        container
          .querySelectorAll(SECTION_SELECTOR)
          .forEach(initializeSection);
      });
  }

  function scheduleRefresh() {
    if (refreshFrame) {
      cancelAnimationFrame(refreshFrame);
    }

    refreshFrame = requestAnimationFrame(() => {
      refreshFrame = null;
      initializeAll();
    });
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest(
      ".lamel-frequency__button"
    );

    if (trigger) {
      event.preventDefault();
      event.stopPropagation();

      const accordion = trigger.closest(".lamel-frequency");
      const isOpen = accordion.classList.toggle("is-open");

      trigger.setAttribute(
        "aria-expanded",
        isOpen ? "true" : "false"
      );

      return;
    }

    const optionButton = event.target.closest(
      ".lamel-frequency__option"
    );

    if (optionButton) {
      event.preventDefault();
      event.stopPropagation();

      const section = optionButton.closest(SECTION_SELECTOR);
      const accordion = optionButton.closest(".lamel-frequency");
      const data = getSelectData(section);
      const { subscriptionInput } = getGroups(section);

      if (!data) {
        return;
      }

      data.select.value = optionButton.dataset.value;

      data.select.dispatchEvent(
        new Event("input", {
          bubbles: true,
        })
      );

      data.select.dispatchEvent(
        new Event("change", {
          bubbles: true,
        })
      );

      setRadio(subscriptionInput);

      accordion.classList.remove("is-open");

      accordion
        .querySelector(".lamel-frequency__button")
        ?.setAttribute("aria-expanded", "false");

      requestAnimationFrame(() => {
        syncSection(section);
      });

      return;
    }

    const subscriptionGroup = event.target.closest(
      ".subscription_group"
    );

    if (
      subscriptionGroup &&
      !event.target.closest(
        "input, select, option, button, a"
      )
    ) {
      const radio = subscriptionGroup.querySelector(
        'input[type="radio"]'
      );

      setRadio(radio);

      const section = subscriptionGroup.closest(SECTION_SELECTOR);

      requestAnimationFrame(() => {
        syncSection(section);
      });

      return;
    }

    document
      .querySelectorAll(".lamel-frequency.is-open")
      .forEach((accordion) => {
        if (!accordion.contains(event.target)) {
          accordion.classList.remove("is-open");

          accordion
            .querySelector(".lamel-frequency__button")
            ?.setAttribute("aria-expanded", "false");
        }
      });
  });

  document.addEventListener("change", (event) => {
    const section = event.target.closest(SECTION_SELECTOR);

    if (section) {
      requestAnimationFrame(() => {
        syncSection(section);
      });

      return;
    }

    if (
      event.target.matches(
        'input[name="id"], select[name="id"]'
      )
    ) {
      scheduleRefresh();
    }
  });

  document.addEventListener("variant:change", scheduleRefresh);
  document.addEventListener(
    "product:variant-change",
    scheduleRefresh
  );
  document.addEventListener(
    "shopify:section:load",
    scheduleRefresh
  );
  document.addEventListener(
    "shopify:section:reorder",
    scheduleRefresh
  );

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeAll,
      {
        once: true,
      }
    );
  } else {
    initializeAll();
  }
})();
